module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid card-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-desktop-side-x"
  }, [_c('desktop-sidebar-mini')], 1), _vm._v(" "), _c('div', {
    staticClass: "card-desktop-main-x",
    staticStyle: {
      "margin-left": "7%",
      "width": "63%"
    }
  }, [_c('div', {
    staticClass: "card card-desktop-body-x"
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "1.2em"
    }
  }, [_c('div', {
    staticClass: "card-cd-head",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "-0.06em"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), (_vm.set_app_operator) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('b', [_vm._v("Staff: " + _vm._s(_vm.user.user_name))])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-cd-categories"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "category-slide-x"
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('li', {
    staticClass: "c-menu-active"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.getSellpointProducts();
      }
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v("All")]), _vm._v(" "), _c('h6', {
    staticClass: "prd-name-2-lines"
  }, [_vm._v("All")])])]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(data, index) {
    return _c('li', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.category = data;
          _vm.getBusinessCategoryProducts();
        }
      }
    }, [_c('p', {
      staticClass: "ltr-1"
    }, [_vm._v(_vm._s(data.business_category_name))]), _vm._v(" "), _c('h6', {
      staticClass: "prd-name-2-lines"
    }, [_vm._v(_vm._s(data.business_category_name))])])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('moreCategories');
      }
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v("More")]), _vm._v(" "), _c('h6', {
    staticClass: "prd-name-2-lines"
  }, [_vm._v("More")])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-cd-body"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('items-list'), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "display": "none",
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [(_vm.menu_tab_inner_view['viewProduct']) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [(_vm.product && (Object.keys(_vm.product).length > 0)) ? _c('div', {
    attrs: {
      "id": "productBoxX"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('a', {
    staticStyle: {
      "z-index": "5",
      "display": "block",
      "margin-top": "0.1em",
      "margin-left": "0em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-img-boxxx"
  }, [(_vm.product.product_images[0]) ? _c('img', {
    staticClass: "card-col-imgxx",
    attrs: {
      "id": "el-image",
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0",
      "margin-bottom": "15em",
      "padding": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#757575"
    }
  }), _vm._v(" "), (_vm.product.product_description != '') ? _c('div', [_c('p', {
    staticClass: "prd-descr",
    attrs: {
      "id": "pLess"
    }
  }, [_c('span', {
    staticClass: "max-lines"
  }, [_vm._v(_vm._s(_vm.product.product_description) + ".")]), _vm._v(" "), ((_vm.product.product_description).length > 150) ? _c('span', [_vm._v(".."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("more")])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pMore"
    }
  }, [_vm._v(_vm._s(_vm.product.product_description) + "...."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("less")])])]) : _vm._e(), _vm._v(" "), (((_vm.product.product_description == '') || ((_vm.product.product_description).length < 150))) ? _c('div', [_c('p', {
    staticClass: "prd-descr",
    staticStyle: {
      "line-height": "1.8",
      "color": "#757575"
    }
  }, [_vm._v("Enjoy " + _vm._s(_vm.product.product_name) + " from " + _vm._s(_vm.app_name) + ", we are here to serve you with your best local and \r\n                                                  international dishes. To enjoy this meal, select the number of quantities you want, place your order, \r\n                                                  and send evidence of payment, we will contct you with your order details.\r\n                                                ")])]) : _vm._e()]), _vm._v(" "), (_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 1)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_c('h4', [_vm._v("Please select from (" + _vm._s(_vm.product.product_items.length) + ") below options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {}, [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.2em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-1 mp0"
    }, [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(2, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductItem(item, product_item_index);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('p', [(product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('p', [_c('span', {
      attrs: {
        "id": 'prdQty' + product_item_index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 mp0"
    }, [_c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])
  })], 2) : _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', [_vm._v("Quantity")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "id": 'prdQty' + _vm.product_index
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "5px 6px 8px 6px",
      "border-radius": "50%",
      "line-height": "0.2",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "1 0.81em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "5px 6px 10px 6px",
      "border-radius": "50%",
      "line-height": "0.6",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "fixed",
      "bottom": "0",
      "z-index": "1",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#999",
      "font-size": "13px"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "-0.12em"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.product_item.product_item_price_f))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.checkProductOrderItems(_vm.product)) ? _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "border-radius": "8px",
      "padding": "15px 38px",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Select")]) : _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "border-radius": "8px",
      "padding": "15px 38px",
      "background-color": "#f7df2b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Select")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])]) : _vm._e()]) : _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('items-list'), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "height": "2.5em",
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "2em",
      "color": "#000000"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143b203a"}!./src/pages/Business/desktop/desktop.html
// module id = 534
// module chunks = 0